import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import getToastStyle from "./utils/getToastStyle";
import cn from "../../utils/cn";
import Icon from "../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Toast = _ref => {
  let {
    id,
    message,
    type,
    dataTestId,
    autoClose = 5000,
    onClose,
    className = "",
    preventCloseOnHover = false,
    preventAutoClose = false
  } = _ref;
  const [isExiting, setIsExiting] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [toastStyle, icon, iconColor] = getToastStyle(type);
  const isSystemAlertBanner = type === 'system-alert-banner';
  const toastClassName = cn(`p-5 border rounded flex justify-between items-center text-sm ${toastStyle} leading-5 font-heavy-font transition-all duration-500 shadow-lg ${isExiting ? "animate-slide-up" : "animate-slide-down"}`, `${isSystemAlertBanner ? "text-white" : "text-text-blue"}`, className);
  const iconClassName = cn(isSystemAlertBanner ? "bg-white rounded-full" : null);
  const closeColorIcon = isSystemAlertBanner ? 'white' : 'medium-grey';
  useEffect(() => {
    if (preventAutoClose) {
      return;
    }
    if (preventCloseOnHover && isHovering) {
      return;
    }
    const exitTimer = setTimeout(() => setIsExiting(true), autoClose - 500);
    return () => clearTimeout(exitTimer);
  }, [autoClose, isHovering, preventCloseOnHover, preventAutoClose]);
  useEffect(() => {
    if (isExiting) {
      const removeTimer = setTimeout(() => onClose(id), 500);
      return () => clearTimeout(removeTimer);
    }
  }, [isExiting, id, onClose]);
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": dataTestId,
    className: toastClassName,
    onMouseOver: () => setIsHovering(true),
    onMouseOut: () => setIsHovering(false),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex",
      children: [/*#__PURE__*/_jsx(Icon, {
        className: iconClassName,
        icon: icon,
        color: iconColor,
        size: 20
      }), /*#__PURE__*/_jsx("div", {
        className: "ml-4",
        children: message
      })]
    }), /*#__PURE__*/_jsx("button", {
      onClick: () => setIsExiting(true),
      "aria-label": "Close",
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "Cross",
        size: 14,
        color: closeColorIcon,
        className: "hover:text-dark-grey"
      })
    })]
  });
};
Toast.propTypes = {
  id: PropTypes.number.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.oneOf(["success", "info", "error", "warning", "system-alert-banner"]).isRequired,
  dataTestId: PropTypes.string.isRequired,
  autoClose: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  preventCloseOnHover: PropTypes.bool,
  preventAutoClose: PropTypes.bool
};
export default Toast;
//# sourceMappingURL=Toast.js.map